import React, { useState } from 'react';
import AccountInfoTab from '@/pages/AccountPage/tabs/AccountInfoTab';
import PasswordTab from "@/pages/AccountPage/tabs/PasswordTab";
import NotificationsTab from "@/pages/AccountPage/tabs/NotificationsTab";
import SupportTab from "@/pages/AccountPage/tabs/SupportTab";
// После добавления остальных вкладок — импортируешь аналогично:
// import { AccountPasswordTab } from '@/features/account/components/AccountPasswordTab';

const tabs = [
    { key: 'info', label: 'Мои данные' },
    { key: 'password', label: 'Пароль' },
    { key: 'notifications', label: 'Уведомления' },
    { key: 'support', label: 'Поддержка' },
];

export const AccountPage: React.FC = () => {
    const [activeTab, setActiveTab] = useState('info');

    const renderTabContent = () => {
        switch (activeTab) {
            case 'info':
                return <AccountInfoTab />;
                case 'password':
                    return <PasswordTab />;
                    case 'notifications':
                        return <NotificationsTab />;
                        case 'support':
                            return <SupportTab />;
            default:
                return (<p>Раздел в разработке...</p>);
        }
    };

    return (
        <main className="layout__content layout__content_padding_sm">
            <div className="container">
                <nav className="list-nav">
                    <ul className="list-ul">
                        <li className="list-item untested-link"><a className="list-link"
                                                                   href="https://test.bionmax.ru/online-check/">
                            <svg className="list-icon">
                                <use
                                    href="/img/sprite-icons.svg#continue"></use>
                            </svg>
                            <span className="list-text">Продолжить чекап</span></a></li>
                        <span className="nav__untested-text">После завершения чекапа теста на состояние здоровья, мы сможем предоставить индивидуальные рекомендации для поддержания и улучшения вашего здоровья.</span>
                    </ul>
                </nav>
                <div className="profile__inner">
                    <aside className="profile__sidebar">
                        <nav className="profile-nav">
                            <ul className="profile-nav__list">
                                {tabs.map((tab) => (
                                    <li
                                        key={tab.key}
                                        className={`profile-nav__item ${activeTab === tab.key ? 'profile-nav__item_active' : ''}`}
                                    >
                                        <button
                                            className="profile-nav__link"
                                            onClick={() => setActiveTab(tab.key)}
                                        >
                                            {tab.label}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </aside>
                    <div className="profile__content">
                        {renderTabContent()}
                    </div>
                </div>
            </div>
        </main>

            );
            };
